import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { BreadcrumbService } from '../../app/services/breadcrumbs.service';
import * as pdActions from '../actions/pd.actions';

@Injectable()
export class RouterEffects {
  private actions$ = inject(Actions);
  private breadcrumbService = inject(BreadcrumbService);
  private router = inject(Router);

  updateBreadcrumbs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(routerNavigatedAction),
      map(() => {
        const root = this.router.routerState.snapshot.root;

        // Calculate the breadcrumbs
        const breadcrumbs = this.breadcrumbService.createBreadcrumbs(root);

        // update the store
        return pdActions.setBreadcrumbs({ breadcrumbs });
      })
    )
  );
}
